import React from 'react';
import { Link } from 'react-router-dom';

const ComingSoon = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="text-center">
        <img src="/img/pana.png" alt="Coming Soon" className="img-fluid mb-4" style={{ maxWidth: '350px' }} />
        <h1 className="display-4 mb-3">🚀 Coming Soon</h1>
        <p className="lead">We're building something amazing! Stay tuned.</p>
        <Link to="/" className="btn btn-primary rounded-pill mt-4 py-3 px-5">Go to Home</Link>
      </div>
    </div>
  );
};

export default ComingSoon;
